import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class ModifierQuantity extends React.Component {
    static propTypes = {
        quantity: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        canIncrease: PropTypes.bool,
    };

    static defaultProps = {
        canIncrease: true,
    };

    static getDerivedStateFromProps(props, state) {
        state.quantity = props.quantity;
        return state;
    }

    state = {
        quantity: 0,
        is_focused: false,
    };

    onIncreaseClick = () => {
        this.props.onChange(this.state.quantity + 1);
    };

    onDecreaseClick = () => {
        this.props.onChange(this.state.quantity - 1);
    };

    onInputChange = e => {
        let value = +e.target.value;

        if (value < 0 || _.isNaN(value)) {
            value = 0;
        }
        if (value > 1000) {
            value = 1000;
        }
        this.props.onChange(value);
    };

    render() {
        return (
            <div className="m2g-product-editor-modifier-quantity-control">
                <div
                    className={`m2g-product-editor-modifier-quantity-control-button
                        ${
                            this.state.quantity === 0
                                ? 'm2g-product-editor-modifier-quantity-control-button--disabled'
                                : ''
                        }
                        m2g-product-editor-modifier-quantity-control-button--decrease
                        m2g-touchable`}
                    onClick={this.onDecreaseClick}
                >
                    <span className="m2g-product-editor-modifier-quantity-control-button-content">
                        –
                    </span>
                </div>
                <input
                    data-quantity-text
                    type="tel"
                    value={`${
                        this.state.is_focused && this.state.quantity !== null
                            ? this.state.quantity
                            : this.props.quantity
                    }`}
                    onChange={this.onInputChange}
                    onFocus={() => this.setState({ is_focused: true })}
                    onBlur={() => this.setState({ is_focused: false })}
                    className="m2g-product-editor-modifier-quantity-control-text-input"
                />
                <div
                    className={`m2g-product-editor-modifier-quantity-control-button
                        ${
                            this.props.canIncrease
                                ? ''
                                : 'm2g-product-editor-modifier-quantity-control-button--disabled'
                        }
                        m2g-product-editor-modifier-quantity-control-button--increase
                        m2g-touchable`}
                    onClick={this.onIncreaseClick}
                >
                    <span className="m2g-product-editor-modifier-quantity-control-button-content">
                        +
                    </span>
                </div>
            </div>
        );
    }
}

export default ModifierQuantity;
